import React from 'react'

function GaleryItem(props) {
    return (
        <div className="col-md-4">
            <div className="gallery-item">                
                    <img src={props.img} alt={props.desc} className="img-fluid"/>
                    
           
            </div>        
        </div> 
    )
}

export default GaleryItem
